module.exports = __webpack_public_path__ + "img/myloby_logo.4928e26d.svg";